export default {"src":"/_next/static/media/qlife-logo.351fbe7e.svg","height":22,"width":79,"blurWidth":0,"blurHeight":0};